<template>
  <section class="ad-container">
    <div class="flex-container">
      <h1>Stickers & borden</h1>
      <p class="sub-title">Kant-en-klaar, snel bezorgd.</p>

      <div class="products" :class="{ 'count-6': maxCount < 7 }">
        <button
          class="product pointer"
          v-for="product in products"
          :key="product.id"
          @click="gotoProduct(product)"
          :style="{
            backgroundImage: setImgUrl(product)
          }"
        ></button>
      </div>

      <div class="btn-holder">
        <button class="pill-button-lg" @click="gotoPrintStore">
          Bekijk het volledige aanbod
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import { getRandomPrintStoreProducts } from '@/features/printstore/PrintStoreApi'

export default {
  props: ['maxCount'],
  data() {
    return {
      products: [{}, {}, {}, {}]
    }
  },
  methods: {
    gotoProduct(product) {
      this.$router.push({
        name: 'printStoreProduct',
        params: {
          categoryId: product.collections[0].categoryId,
          collectionId: product.collections[0].id,
          productId: product.id
        }
      })
    },
    gotoPrintStore() {
      this.$router.push({
        name: 'printStore'
      })
    },
    setImgUrl(product) {
      const psID = product.printStoreId

      const image =
        product.hasVariants && product.previews.length > 0
          ? product.previews[
              Math.floor(Math.random() * product.previews.length)
            ].uuid
          : product.previewImage

      /*  const image = product.hasVariants
        ? product.previews[0].uuid
        : product.previewImage */

      return image ? `url(/media/print-store/${psID}/preview/${image}/150)` : ''
    }
  },
  mounted() {
    const count = this.maxCount || 9
    const adPrefs = this.rootStore.theme.customFields.printStoreAd
    const select = adPrefs.onlyDefault
      ? 'DEFAULT_ONLY'
      : adPrefs.includeDefault
      ? 'INCLUDE_DEFAULT'
      : ''
    getRandomPrintStoreProducts(count, select).then((resp) => {
      this.products = resp
    })
  }
}
</script>

<style lang="scss" scoped>
.ad-container {
  padding: 15px;
  height: 100%;
}

.flex-container {
  box-shadow: var(--default-shadow);
  border-radius: 25px;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px 0 15px;
  max-width: 290px;
  overflow: hidden;
}

h1 {
  font-size: 19px;
  font-weight: 500;
  margin-bottom: 7px;
  text-align: center;
  color: #4f4f4f;
}

.sub-title {
  text-align: center;
}

.text {
  text-align: center;
}

.products-container {
}

.products {
  padding-top: 20px;
  padding-bottom: 10px;
  margin-left: -52px;
  display: grid;
  grid-template-columns: 105px 105px 105px;
  grid-template-rows: 105px 105px 105px;
  column-gap: 40px;
  row-gap: 30px;

  &.count-6 {
    grid-template-rows: 105px 105px;
  }
}

.product {
  /* width: 33.3%px;
  height: 105px;
  margin-bottom: 25px;
  */
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.btn-holder {
  margin-top: auto;
  padding: 0 15px;
  text-align: center;

  button {
    max-width: 300px;
    width: 100%;
    background: white;
    color: var(--sub-color);
  }
}

@media only screen and (min-width: 620px) {
  .product {
    //  width: 95px;
  }
}

@media only screen and (min-height: 920px) {
  /* .product {
    &:nth-child(5),
    &:nth-child(6) {
      display: block;
    }
  } */
}
</style>
